import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ParticipantsComponent} from "./components/participants/participants.component";
import {EventsComponent} from "./components/events/events.component";
import {TagBibComponent} from "./components/tag-bib/tag-bib.component";
import {LogsComponent} from "./components/logs/logs.component";
import {MassAssignmentComponent} from "./components/mass-assignment/mass-assignment.component";
import {UsersComponent} from "./components/users/users.component";

const routes: Routes = [
  {path: '', redirectTo: '/events', pathMatch: 'full'},
  {path: 'events/:id/participants', component: ParticipantsComponent},
  {path: 'events/:id/tag-bib', component: TagBibComponent},
  {path: 'events', component: EventsComponent},
  {path: 'users', component: UsersComponent},
  {path: 'logs', component: LogsComponent},
  {path: 'events/:id/mass-assignment', component: MassAssignmentComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
